"use client";

import { c as _c } from "react/compiler-runtime";
import { getMedications } from "@/lib/patient-health-fields";
import type { PatientChart } from "@/types/patient";
export default function PatientReportedMedicationsSection(t0) {
  const $ = _c(8);
  const {
    patient
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== patient) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const medications = getMedications(patient);
      if (medications.length === 0) {
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <p className="text-caption text-muted-foreground">None recorded</p>;
          $[4] = t4;
        } else {
          t4 = $[4];
        }
        t3 = t4;
        break bb0;
      }
      t1 = "space-y-1";
      t2 = medications.map(_temp);
    }
    $[0] = patient;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <ul className={t1}>{t2}</ul>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(medication, idx) {
  return <li key={idx} className="text-body text-foreground">{medication}</li>;
}